<template>
  <div>
    <div class="w-full space-y-6">
      <h2 class="font-serif text-3xl font-bold text-center text-gray-900">Reset Password</h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="password"
          placeholder="New Password"
          v-model="password"
          required
          class="form-input"
        />
        <button
          type="submit"
          class="btn-cream w-full py-3"
        >
          Update Password
        </button>
      </form>

      <button @click="$emit('switch','login')" class="text-brand-red font-medium hover:underline text-sm w-full text-center">
        Back to Login
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const emit = defineEmits(["success","error","switch"]);

const password = ref("");
const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";
// We store contact for reset flow in sessionStorage under "resetContact"
const contact = sessionStorage.getItem("resetContact");

const submit = async () => {
  if (!contact) {
    return emit("error", "No contact found for password reset.");
  }
  try {
    const res = await fetch(`${baseUrl}/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contact, newPassword: password.value }),
    });
    const data = await res.json();
    if (!res.ok) return emit("error", data.error || "Failed to reset password!");
    emit("success","Password updated!");
    emit("switch","login");
  } catch {
    emit("error","Connection error");
  }
};
</script>
